var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SectionCards',[(_vm.permissions.isEnabledInventorySkills)?_c('InventoryCard'):_vm._e(),_vm._v(" "),_c('AddSkillsCard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }